import "../../styles/styles.scss";
import React from "react";
import { store } from "../../reducer/Store";
import { Dropdown, Spinner } from "react-bootstrap";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ApiService from "../../services/ApiService";
import FormRegisterUpdate from "../../components/FormRegisterAndUpdateUser";
import AccordionUsers from "../../components/AccordionUsers";

const Utilisateurs = () => {
  const { dispatch, state } = React.useContext(store);
  const [loader, setLoader] = React.useState(false);
  const [showUpdate, setShowUpdate] = React.useState(false);
  const [showUpdatePassword, setShowUpdatePassword] = React.useState(false);
  const [showAdd, setShowAdd] = React.useState(false);
  const [errorPassword, setErrorPassword] = React.useState("");
  const [errorMail, setErrorMail] = React.useState("");
  const [name, setName] = React.useState("");
  const [id, setId] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [pwd, setPwd] = React.useState("");
  const [pwdConfirm, setPwdConfirm] = React.useState("");
  const [role, setRole] = React.useState("");
  const [brand, setBrand] = React.useState([]);

  const handleClose = () => {
    setShowAdd(false);
    setShowUpdate(false);
    setShowUpdatePassword(false);
    cleanForm();
  };

  const handleShowAdd = () => setShowAdd(true);

  const handleShowUpdate = (user) => {
    setName(user.name);
    setEmail(user.email);
    setRole(user.role);
    setId(user.id);
    var tab = [];
    user.brand_users.map((e) =>
      state.listBrands.filter((brand) =>
        brand.value === e.brand_id.toString() ? tab.push(brand) : ""
      )
    );
    setBrand(tab);
    setShowUpdate(true);
  };

  const handleShowUpdatePassword = (user) => {
    setId(user.id);
    setShowUpdatePassword(true);
  };

  const cleanForm = () => {
    setName("");
    setEmail("");
    setRole("");
    setPwd("");
    setPwdConfirm("");
    setBrand("");
    setErrorMail("");
    setErrorPassword("");
  };

  /**
   * Envoie une requête GET à l'API pour récupérer la liste des utilisateurs.
   * @return {Promise<void>}
   */
  const getUtilisateurs = async () => {
    setLoader(true);
    ApiService.request({}, "users", "get")
      .then(function (response) {
        setLoader(false);
        dispatch({ type: "SET_USERS", payload: response.data });
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction gère l'enregistrement d'un nouvel utilisateur en utilisant les informations fournies dans le formulaire d'inscription.
   * Elle envoie une requête POST à l'API pour créer un nouvel utilisateur avec les données spécifiées.
   * Si l'enregistrement réussit, les utilisateurs sont récupérés à partir de l'API et le formulaire de dialogue est fermé.
   * Si l'enregistrement échoue, des erreurs sont affichées pour informer l'utilisateur des problèmes rencontrés (par exemple, email déjà utilisé, mots de passe non identiques).
   * @param {Object} e - L'événement de soumission du formulaire.
   * @param { String } name - Le nom de l'utilisateur.
   * @param { String } email - L'email de l'utilisateur.
   * @param { String } pwd - Le mot de passe de l'utilisateur.
   * @param { String } pwdConfirm - Le mot de passe de l'utilisateur.
   * @param { String } role - Le rôle de l'utilisateur.
   * @param { String } brand_users - Les marques associées à l'utilisateur.
   */
  const registerUser = async (e) => {
    e.preventDefault();
    setLoader(true);
    const user = {
      name: name,
      email: email,
      password: pwd,
      confirm_password: pwdConfirm,
      role: role,
      brand_users: role === "5" ? brand.map((e) => e.value) : [],
    };
    ApiService.request(user, "register", "post")
      .then(function () {
        setLoader(false);
        getUtilisateurs();
        handleClose();
      })
      .catch(function (error) {
        setLoader(false);
        setErrorMail("");

        setErrorPassword("");
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
        if (error.response.data.message === "Validation error.") {
          error.response.data.data.email
            ? setErrorMail("Email déjà utilisée.")
            : setErrorPassword(
                "Les champs mot de passe et la confirmation de mot de passe doivent être identitques."
              );
        }
      });
  };

  /**
   * Met à jour les informations d'un utilisateur
   * @param {Object} e - L'événement de soumission du formulaire.
   * @param { String } name - Le nom de l'utilisateur.
   * @param { String } email - L'email de l'utilisateur.
   * @param { String } role - Le rôle de l'utilisateur.
   * @param { String } brand_users - Les marques associées à l'utilisateur.
   * @param { Number } id - L'identification de l'utilisateur à mettre à jour.
   */
  const updateUser = async (e) => {
    e.preventDefault();
    setLoader(true);
    const user = {
      name: name,
      email: email,
      role: role,
      brand_users: role.toString() === "5" ? brand.map((e) => e.value) : [],
    };
    ApiService.request(user, "users/" + id, "put")
      .then(function () {
        setLoader(false);
        getUtilisateurs();
        handleClose();
      })
      .catch(function (error) {
        setLoader(false);
        setErrorMail("");
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
        if (error.response.data.message === "Error validation.") {
          error.response.data.data.email
            ? setErrorMail("Email déjà utilisée.")
            : console.log(error.response.data);
        }
      });
  };

  /**
   * Met à jour le mot de passe de l'utilisateur.
   * @param {Object} e - L'événement de soumission du formulaire.
   * @param { String } pwd - Le mot de passe de l'utilisateur.
   * @param { String } pwdConfirm - Le mot de passe de l'utilisateur.
   * @param { Number } id - L'identification de l'utilisateur à mettre à jour.
   */
  const updateUserPassword = async (e) => {
    e.preventDefault();
    setLoader(true);
    const user = {
      password: pwd,
      confirm_password: pwdConfirm,
    };
    ApiService.request(user, "user-password/" + id, "put")
      .then(function () {
        setLoader(false);
        getUtilisateurs();
        handleClose();
      })
      .catch(function (error) {
        setLoader(false);
        setErrorMail("");
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
        if (
          error.response.data.message ===
          "User password different from confirm_password."
        ) {
          setErrorPassword(
            "Les champs mot de passe et la confirmation de mot de passe doivent être identitques."
          );
        }
      });
  };

  /**
   * Supprime un utilisateur en effectuant une requête personnalisée à l'API avec fetch api.
   * @param {number} userId - ID de l'utilisateur à supprimer.
   * @return {Promise} - La promesse de la requête pour la suppression de l'utilisateur.
   */
  const deleteUser = async (userId) => {
    if (
      window.confirm(
        "Voulez vous vraiment supprimer cet utilisateur ? Cela est définitif."
      )
    ) {
      ApiService.request({}, "users/" + userId, "delete")
        .then(function () {
          setLoader(false);
          getUtilisateurs();
          handleClose();
        })
        .catch(function (error) {
          setLoader(false);
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Récupère les rôles des utilisateurs en utilisant ApiService.request() pour envoyer une requête GET
   * @return {void}
   */
  const getRoles = async () => {
    setLoader(true);
    ApiService.request({}, "roles", "get")
      .then(function (response) {
        setLoader(false);
        // retirer les rôles qu'on ne veut pas créer
        dispatch({ type: "SET_LISTUSERROLES", payload: response.data });
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction retourne le nom d'un rôle utilisateur en fonction de son identifiant de rôle.
   * @param { Number } roleId - L'identifiant de rôle de l'utilisateur dont on souhaite obtenir le nom.
   * @return { String } - Le nom du rôle utilisateur correspondant à l'identifiant de rôle donné.
   */
  const getNameRole = (roleId) => {
    const nameRole = state.listUserRoles.filter((e) => e.id === roleId);
    return nameRole[0].name ? nameRole[0].name : "";
  };

  /**
   * Cette fonction retourne un tableau des noms de marques associées à un utilisateur.
   * @param { Object } user - L'objet utilisateur dont on souhaite obtenir les noms de marques.
   * @return { Array } - Un tableau contenant les noms de marques associées à l'utilisateur.
   */
  const getNameBrands = (user) => {
    var tabBrands = [];
    user.brand_users.map((e) =>
      state.listBrands.filter((brand) =>
        brand.value === e.brand_id.toString() ? tabBrands.push(brand.label) : ""
      )
    );
    return tabBrands;
  };

  React.useEffect(() => {
    getRoles();
    getUtilisateurs();
  }, []);

  return (
    <>
      <h1>
        Utilisateurs
        <Dropdown className="d-inline-block">
          <Dropdown.Toggle>
            <MoreVertIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={handleShowAdd}>
              Ajouter un utilisateur
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </h1>

      {showAdd && (
        <FormRegisterUpdate
          controlFormId="register"
          show={showAdd}
          registerOrUpdateUser={registerUser}
          name={name}
          email={email}
          pwd={pwd}
          pwdConfirm={pwdConfirm}
          role={role}
          brand={brand}
          setName={setName}
          setPwd={setPwd}
          setPwdConfirm={setPwdConfirm}
          setBrand={setBrand}
          setRole={setRole}
          setEmail={setEmail}
          handleClose={handleClose}
          errorMail={errorMail}
          errorPassword={errorPassword}
        />
      )}
      {showUpdate && (
        <FormRegisterUpdate
          controlFormId={"update-user"}
          registerOrUpdateUser={updateUser}
          show={showUpdate}
          id={id}
          name={name}
          email={email}
          role={role}
          brand={brand}
          setName={setName}
          setPwd={setPwd}
          setBrand={setBrand}
          setRole={setRole}
          setEmail={setEmail}
          handleClose={handleClose}
          getNameRole={getNameRole}
          errorMail={errorMail}
        />
      )}
      {showUpdatePassword && (
        <FormRegisterUpdate
          controlFormId="update-password"
          registerOrUpdateUser={updateUserPassword}
          show={showUpdatePassword}
          id={id}
          pwd={pwd}
          setPwd={setPwd}
          pwdConfirm={pwdConfirm}
          setPwdConfirm={setPwdConfirm}
          handleClose={handleClose}
          errorPassword={errorPassword}
          setErrorPassword={setErrorPassword}
          getNameRole={getNameRole}
        />
      )}
      {!loader ? (
        state.listUserRoles &&
        state.listUserRoles.length > 1 &&
        state.users &&
        state.users.length > 1 &&
        state.users.map((user, key) => (
          <div key={key}>
            <AccordionUsers
              keyProp={key}
              user={user}
              nameRole={getNameRole(user.role)}
              handleShowUpdate={handleShowUpdate}
              handleShowUpdatePassword={handleShowUpdatePassword}
              deleteUser={deleteUser}
              nameBrands={getNameBrands}
            />
          </div>
        ))
      ) : (
        <div className="text-center pt-5">
          <Spinner
            animation={loader ? "border" : false}
            role="status"
          ></Spinner>
        </div>
      )}
    </>
  );
};
export default Utilisateurs;
